import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["img"]

  static values = {
    cropX: Number,
    cropY: Number,
    cropWidth: Number,
    cropHeight: Number,
    originalWidth: Number,
    originalHeight: Number,
    margin: Number,
    border: Boolean,
    borderColor: String,
    finalWidth: Number,
    useRaw: Boolean,
    shadow: Boolean,
    ready: Boolean,
    testLoad: Boolean,
  }

  connect() {
    this.container = this.element

    this.updateVizTimeout = null

    if (!this.readyValue) {
      console.log("avatar vis is not ready stopping now")
      return
    }

    this.updateVisualisation()
    this.testLoad()
  }

  testLoad() {
    if (!this.testLoadValue) return
    setTimeout(() => {
      this.imgTarget.src = "https://sigilium.com/no-results-found.png"
    }, 500)
  }

  imageUpdatedEvent(e) {
    console.log("image updated", e)
    // FIXME (image update)
    if (this.originalWidthValue == 0) {
      this.container.dataset["avatarVisualisationOriginalWidthValue"] =
        this.imgTarget.width
      this.container.dataset["avatarVisualisationOriginalHeightValue"] =
        this.imgTarget.height
      this.updateVisualisation()
    }
  }

  debugMessages() {
    let debugMessages = []
    debugMessages.push(`Visualizer debug`)
    debugMessages.push(`hasBorder: ${this.hasBorder}`)
    debugMessages.push(`margin: ${this.marginValue}`)
    debugMessages.push(`raw: ${this.useRawValue}`)
    debugMessages.push(
      `Container width and height: ${this.containerWidth} x ${this.containerHeight}`
    )

    debugMessages.push(`Container original width: ${this.originalWidthValue}`)
    debugMessages.push(`Container original height: ${this.originalHeightValue}`)
    debugMessages.push(`cropX: ${this.cropXValue}`)
    debugMessages.push(`cropY: ${this.cropYValue}`)
    return debugMessages.join("\n")
  }

  updateVisualisationWithTimeout() {
    clearTimeout(this.updateVizTimeout)
    this.updateVizTimeout = setTimeout(() => {
      this.updateVisualisation()
    }, 10)
  }

  get containerMargin() {
    return Math.max(this.antializingLeak, this.relativeMargin)
  }

  updateVisualisation() {
    if (!this.readyValue) {
      console.log("not ready to display")
      return
    }
    if (this.originalWidthValue == 0) {
      throw "trying to display an image with 0 as originalWidthValue"
    }
    // console.log(this.debugMessages())
    this.container.style.overflow = "hidden"
    this.container.style.marginTop = `${this.containerMargin}px`
    this.container.style.marginLeft = `${this.containerMargin}px`
    this.container.style.position = "relative"
    this.container.style.boxSizing = "border-box"
    this.container.style.width = this.containerWidth
    this.container.style.height = this.containerHeight

    this.container.style.border = this.borderStyle
    this.container.style.borderRadius = this.borderRadius

    this.imgTarget.style.position = "absolute"
    if (this.shadowValue) {
      this.container.style.boxShadow = "0 .125rem .25rem #aaa"
    }

    if (this.useRawValue) {
      this.imgTarget.style.width = this.imgWidthWithoutMargin + "px"
      this.imgTarget.style.height = this.imgHeightWithoutMargin + "px"
      this.imgTarget.style.transform = `translate(0px, 0px)`
    } else {
      this.imgTarget.style.transform = `translate(${this.translateX}px, ${this.translateY}px)`

      this.imgTarget.style.width = `${this.imgTagWidth}px`
      this.imgTarget.style.height = `${this.imgTagHeight}px`
    }

    // we now show it
    this.container.style.opacity = 1
  }

  get translateX() {
    return -(this.cropXValue * this.avatarBoxWidth) / this.originalWidthValue
  }

  get translateY() {
    return -(this.cropYValue * this.avatarBoxHeight) / this.originalHeightValue
  }

  get imgTagWidth() {
    return this.avatarBoxWidth - this.borderSize * 2
  }
  get imgTagHeight() {
    return this.avatarBoxHeight - this.borderSize * 2
  }

  get avatarBoxWidth() {
    let boxWidth =
      (this.imgWidthWithoutMargin * this.originalWidthValue) /
      this.cropWidthValue
    return boxWidth
  }

  get avatarBoxHeight() {
    let boxHeight =
      (this.imgHeightWithoutMargin * this.originalHeightValue) /
      this.cropHeightValue
    // console.log("boxheight", boxHeight)
    return boxHeight
  }

  get containerWidth() {
    return `${this.imgWidthWithoutMargin - this.antializingLeak}px`
  }

  get imgWidthWithoutMargin() {
    return this.finalWidthValue - 2 * this.relativeMargin
  }

  get relativeMargin() {
    // trouver la valeur de margin2 en fonction de la taille de l'image
    // si on a 20 de margin c en px par rapport à 200 ? ou c un % ?
    return (this.marginValue / 200) * this.finalWidthValue
  }

  get containerHeight() {
    return `${this.imgHeightWithoutMargin - this.antializingLeak}px`
  }

  get imgHeightWithoutMargin() {
    return this.finalHeightFromWidth - 2 * this.relativeMargin
  }

  get finalHeightFromWidth() {
    console.log("finalHeightFromWidth : using raw value is", this.useRawValue)
    if (this.useRawValue) {
      return (
        (this.finalWidthValue * this.originalHeightValue) /
        this.originalWidthValue
      )
    } else {
      return this.finalWidthValue
    }
  }

  get borderStyle() {
    if (!this.hasBorder) return "none"
    return `${this.borderSize}px solid #${this.borderColor}`
  }

  get borderRadius() {
    return this.useRawValue ? `0%` : "50%"
  }

  get borderSize() {
    if (!this.hasBorder) return 0
    if (isNaN(parseInt(this.imgWidthWithoutMargin))) return 3
    return parseInt((3.0 / 100) * parseInt(this.imgWidthWithoutMargin))
  }

  get antializingLeak() {
    return 1
  }

  get hasBorder() {
    return this.borderValue && !this.useRawValue
  }

  get borderColor() {
    return this.borderColorValue.replace("#", "")
  }

  borderColorValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  cropHeightColorValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  cropWidthValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  cropYValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  cropXValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  cropYValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  originalWidthValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  originalHeightValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  marginValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  borderValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  widthValueChanged() {
    this.updateVisualisationWithTimeout()
  }

  readyValueChanged() {}

  useRawValueChanged() {
    this.updateVisualisationWithTimeout()
  }
}
